import axios from "axios";


const API_BASE_URL = "https://api.starmarketapi.online/courier1";


const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

const REFRESH_TOKEN_URL = `${API_BASE_URL}/refresh`;

let accessToken = null;
let refreshToken = null;

export const setTokens = (newAccessToken, newRefreshToken) => {
  accessToken = newAccessToken;
  refreshToken = newRefreshToken;
};

// Add request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers = config.headers || {}; // Ensure headers object exists
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      console.log("after authorization");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    refreshToken = localStorage.getItem("refreshToken");
    if (!error.response) {
      // Network error or server not running
      console.error(
        "Server connection failed. Please check if the server is running on port 8080"
      );
      return Promise.reject(
        new Error(
          "Unable to connect to the server. Please ensure the server is running."
        )
      );
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Call refresh token endpoint
        const refreshResponse = await axios.post(REFRESH_TOKEN_URL, {
          refreshToken,
        });
        accessToken = refreshResponse.data.accessToken;
        refreshToken = refreshResponse.data.refreshToken;
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        // Update Axios Authorization header
        apiClient.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        console.log("refresh token is working");
        // Retry the original request with new token
        return apiClient(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        // Optionally, redirect to login page if refresh fails
        return Promise.reject(refreshError);
      }
    } else if (error.response.status === 401) {
      // Handle unauthorized error
      // You might want to redirect to login or refresh token
      console.error("Unauthorized access");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
